<div class="back-container">
    <div class="back" routerLink="/">
        <frg-inline-svg stroke="var(--primary)" class="back-icon" src="assets/icons/chevron-left.svg"></frg-inline-svg>
        <div class="back-text">Connexion</div>
    </div>
</div>
<form [formGroup]="docteurForm" class="docteur-card-content" (ngSubmit)="onSubmit()">
    <div class="docteur-list-container">
        <div class="docteur-list-title">Liste de mes délégations</div>
        <div class="docteur-list-search-container">
            <div class="search-container">
                <div class="search-input">
                    <frg-search-input (search)="search = $event"></frg-search-input>
                </div>
            </div>
            <div class="docteur-list" [ngClass]="{'hidden': login}">
                <label class="docteur" *ngFor="let docteur of listDocteur | search: search : 'docteur'">
                    <div class="docteur-name">{{docteur.qualite}} {{docteur.nom}} {{docteur.prenom}}<span *ngIf="docteur.email">({{docteur.email}})</span></div>
                    <input [id]="docteur.nom" type="radio" [value]="docteur" formControlName="docteur" [attr.disabled]="docteur.delegation.disabled ? 'disabled' : null" />
                </label>
                <div class="no-element" *ngIf="listDocteur.length === 0">
                  Aucune délégation
                </div>
            </div>
            <div class="lds-spinner-container" [ngClass]="{'hidden': !login}">
                <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        </div>
    </div>
    <div class="buttons-container">
        <div class="connect-button-container">
            <button type="submit" class="button mail-login">
                Se connecter
                <div class="icon-container">
                    <div class="icon">
                    </div>
                </div>
            </button>
        </div>
    </div>
</form>
